import React, { Component } from 'react';
import { Alert, Row, Col, Badge, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import c from '../../constants/Colors';
import { getData } from '../../store/sagas/perfilApi';
import localStorageCustom from '../../utilitarios/localStorage';
import { notificacion } from '../../utilitarios/util';
import Spinner from "../reusable/Loader";

export class Perfil extends Component {
  static displayName = Perfil.name;

  constructor(props) {
    super(props);
    this.state = {
      perfil: {},
      locales: [],
      loading: true,
      dealer: null,
      linea: null,
      showAlert: false,
      alertTitulo: "",
      alertMensaje: "",
      asociado: {}
    };
  }

  postContraseniaActual = async (_correoElectronico) => {
    this.props.history.push({
      pathname: '/cambiar-contrasenia',
      state: { correoElectronico: _correoElectronico }
    });
  }

  postLocales = async (_locales) => {
    this.props.history.push({
      pathname: '/locales',
      state: { locales: _locales }
    });
  }
  postTransportista = async (_locales) => {
    this.props.history.push({
      pathname: '/transportistas',
      state: { locales: _locales }
    });
  }

  postDispositivos = async (_dispositivos) => {
    this.props.history.push({
      pathname: '/dispositivos',
      state: {
        dispositivos: _dispositivos,
        dealer: this.state.dealer,
        linea: this.state.linea,
        asociado: this.state.asociado
      }
    });
  }
  componentDidMount() {
    window.scrollTo(0, 0)
    let result = localStorageCustom.prototype.getUsuario();
    this.setState({
      dealer: result.dealer,
      linea: result.linea,
      asociado: result.asociado
    }, () => {
      this.postGetData(result.dealer.codcliente, result.dealer.correoElectronico,
        result.linea.vkorg, result.asociado.poblacion, result.linea.canal, result.linea.sector, result.linea.linea);
    })
  }

  render() {
    const { loading, perfil, asociado } = this.state;
    return (
      <div id="mhw">
        <Spinner visible={loading} />
        <div className="desktop">
          <Alert color="danger" className="alert-perfil">
            <div className="container_1080 w-100">
              <SvgAssets icon="icon-info" fill="#fff" />
              Para modificar cualquier información de tu perfil contactar a su representante de venta
            </div>
          </Alert>
        </div>
        <div className="rs_container">
          <button className='btn-icon back mobile'
            onClick={() => this.props.history.push('/dashboard')}
          >
            <SvgAssets icon="icon-arrow-left" fill={c.azulClaro} />
          </button>
          <SvgAssets className="icon" icon="icon-user" fill={c.rojoClaro} />
          <h6 className="title-2">{asociado.razonsSocial}</h6>
          <p className="paragraph-1 azul">Repuestos</p>
          <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
        </div>
        <div className="breadcrumb">
          <Container>
            <ul>
              <li><Link to='/dashboard'>Dashboard</Link></li>
              <li><Link to='/perfil' style={{ pointerEvents: 'none' }}>Mi Perfil</Link></li>
            </ul>
          </Container>
        </div>
        <Container className="py-3" style={{ backgroundColor: '#fff' }}>
          <Alert color="danger" className="alert-perfil mobile">
            <SvgAssets icon="icon-info" fill="#fff" />
            {/* Para editar cualquier información de tu perfil contáctanos al {perfil.telefonoContactanos} */}
            Para modificar cualquier información de tu perfil contactar a su representante de venta
          </Alert>
          <div className="card_desktop container_datos">
            <h6 className="title-3 text-center mb-4 desktop">Datos Personales</h6>
            <Row className='align-items-perfil'>
              <Col md={6}>
                <div className="campo-perfil">
                  <div className="icon" style={{ backgroundColor: c.naranja }}>
                    <SvgAssets icon="icon-cod-cli" fill="#fff" />
                  </div>
                  <div className="text">
                    <span className="paragraph-2 mb-1" style={{ color: c.azulClaro }}>Código de cliente SAP</span>
                    <span className="paragraph-1" style={{ color: c.grisMedio }}>{asociado.codigoDealer}</span>
                  </div>
                </div>
                <div className="campo-perfil">
                  <div className="icon" style={{ backgroundColor: c.verdeClaro }}>
                    <SvgAssets icon="icon-mail" fill="#fff" />
                  </div>
                  <div className="text">
                    <span className="paragraph-2 mb-1" style={{ color: c.azulClaro }}>Email</span>
                    <span className="paragraph-1" style={{ color: c.grisMedio }}>{perfil.correoElectronico}</span>
                  </div>
                </div>
              </Col>
              <Col md={6}>
                <div className="campo-perfil">
                  <div className="icon" style={{ backgroundColor: c.rojoClaro }}>
                    <SvgAssets icon="icon-user" fill="#fff" />
                  </div>
                  <div className="text">
                    <span className="paragraph-2 mb-1" style={{ color: c.azulClaro }}>Nombre</span>
                    <span className="paragraph-1" style={{ color: c.grisMedio }}>{asociado.razonsSocial}</span>
                  </div>
                </div>
                <div className="campo-perfil">
                  <div className="icon" style={{ backgroundColor: c.morado }}>
                    <SvgAssets icon="icon-phone" fill="#fff" />
                  </div>
                  <div className="text">
                    <span className="paragraph-2 mb-1" style={{ color: c.azulClaro }}>Teléfono</span>
                    <span className="paragraph-1" style={{ color: c.grisMedio }}>9578852314</span>
                  </div>
                </div>
              </Col>
            </Row>
          </div>

          <ul className="options-perfil">
            <li className='mobile'>
              {/* <Link to="/locales"> */}
              <a href="#" style={{ color: c.naranja }}
                onClick={(e) => { e.preventDefault(); this.postTransportista(perfil.traspor); }}
              >
                <SvgAssets icon="icon-local" fill={c.naranja} />
                Transportistas
                <SvgAssets icon="icon-right" className="arrow" fill={c.naranja} />
              </a>
              {/* </Link> */}
            </li>
            <li>
              {/* <Link to="/locales"> */}
              <a href="#" style={{ color: c.verdeClaro }}
                onClick={(e) => { e.preventDefault(); this.postLocales(perfil.locales); }}
              >
                <SvgAssets icon="icon-local" fill={c.verdeClaro} />
                Locales
                <SvgAssets icon="icon-right" className="arrow" fill={c.verdeClaro} />
              </a>
              {/* </Link> */}
            </li>
            <li>
              {/* <Link to="/dispositivos"> */}
              <a href="#" style={{ color: c.morado }}
                onClick={(e) => { e.preventDefault(); this.postDispositivos(perfil.dispositivos) }}
              >
                <SvgAssets icon="icon-phone" fill={c.morado} />
                Dispositivos
                <SvgAssets icon="icon-right" className="arrow" fill={c.morado} />
              </a>
              {/* </Link> */}
            </li>
            <li>
              {/* <Link to="/cambiar-contrasenia"> */}
              <a href="#" style={{ color: c.azulClaro }}
                onClick={(e) => { e.preventDefault(); this.postContraseniaActual(perfil.correoElectronico) }}
              >
                <SvgAssets icon="icon-lock" fill={c.azulClaro} />
                Cambiar contraseña
                <SvgAssets icon="icon-right" className="arrow" fill={c.azulClaro} />
              </a>
              {/* </Link> */}
            </li>
            <li className='desktop'>
              {/* <Link to="/locales"> */}
              <a href="#" style={{ color: c.naranja }}
                onClick={(e) => { e.preventDefault(); this.postTransportista(perfil.traspor); }}
              >
                <SvgAssets icon="icon-local" fill={c.naranja} />
                Transportistas
                <SvgAssets icon="icon-right" className="arrow" fill={c.naranja} />
              </a>
              {/* </Link> */}
            </li>
          </ul>
        </Container>
      </div>
    );
  }

  postGetData = async (CodigoDealer, CorreoElectronico, VKorg, Poblacion, Canal, Sector, linea) => {
    getData(CodigoDealer, CorreoElectronico, VKorg, Poblacion, Canal, Sector, linea)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({
            loading: false,
            locales: result.dto.locales,
            perfil: result.dto.perfil
          })
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Perfil", error.message ?? null);
        });
      });

  }
}
